import { api } from '@creditsights/api-ui-web';
import { SearchSuggestItem } from '../../models/SearchSuggest';

export const fetchSearchSuggest = async (term: string): Promise<SearchSuggestItem[]> => {
  const { data } = await api.get<SearchSuggestItem[]>(
    `/common/v1/tags/suggest?term=${encodeURIComponent(term)}&take=10`
  );
  return data;
};
